import { Card, Table } from "react-bootstrap"
import Affiliate from "../../../templates/Affiliate/Affiliate"
import { DollarSign } from "react-feather"
import Dollars from "../../../templates/Dollars/Dollars"
import ReportsMoreAvatar from "../AvatarReports/AvatarReportsMore/AvatarReportsMore"
import moment from "moment"
import useCallApi from "../../../hooks/useCallApi"
import Campaign from "../../../templates/Campaign/Campaign"
import Number from "../../../templates/Number/Number"
import Loading from "../../../templates/UI/Loading/Loading"
import { Link } from "react-router-dom/cjs/react-router-dom.min"

const TopX = ({ title, type, startDate, endDate, order }) => {

    const { data, dataLoaded } = useCallApi(`reports/campaigns?startDate=${startDate}&endDate=${endDate}&affiliateId=573358&withAvatar=true&navigation=affiliate`, 'GET', {}, [])

    return (
        <Card className="mt-3">
            <Card.Header className='d-flex align-items-center justify-content-between'>
                <h1 className="mb-h1-dark">{title}</h1>
                <div><Link to={`/reports/stats/campaigns?startDate=${startDate}&endDate=${endDate}&affiliateId=573358&withAvatar=true&navigation=affiliate`}>Full Report</Link></div>
            </Card.Header>
            <Card.Body className="p-0">
                <Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Campaign</th>
                            <th className="text-right">Clicks</th>
                            <th className="text-right">Conversions</th>
                            <th className="text-right">CR%</th>
                            <th className="text-right">Net Earnings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ?
                            data.report.length > 0 ?
                                data.report
                                    .sort((a, b) => {
                                        if (order === 'desc') {
                                        return b[type] - a[type]
                                    }
                                    return a[type] - b[type]
                                })
                                .map((item, index) => {
                                    if (index < 10) {
                                        return (
                                            <tr key={item.campaign_id}>
                                                <td>{item.campaign_id}</td>
                                                <td><Campaign name={item.campaign.name} oid={item.campaign.id} status={item.campaign.status.value} /></td>
                                                <td align="right"><Number value={item.clicks} /></td>
                                                <td align="right"><Number value={item.conversions} /></td>
                                                <td align="right"><Number value={item.conversion_ratio} />%</td>
                                                <td align="right"><Dollars value={item.network_earnings} /></td>
                                            </tr>
                                        )
                                    }
                                })
                            :
                                <tr>
                                    <td colSpan="6" className="text-center">No data found</td>
                                </tr>
                        :
                            <tr>
                                <td colSpan="6" className="text-center"><Loading /></td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </Card.Body>

        </Card>
    )
}

export default TopX
